var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "resize",
          rawName: "v-resize",
          value: _vm.updatePosPicker,
          expression: "updatePosPicker"
        }
      ]
    },
    [
      _c(
        "v-tooltip",
        {
          attrs: { top: "" },
          scopedSlots: _vm._u([
            {
              key: "activator",
              fn: function(ref) {
                var on = ref.on
                return [
                  _c(
                    "v-btn",
                    _vm._g(
                      {
                        staticClass: "tf-icone-toolbar-chat",
                        attrs: {
                          flat: !_vm.picker,
                          icon: "",
                          color: "primary"
                        },
                        on: { click: _vm.showPicker }
                      },
                      on
                    ),
                    [_c("v-icon", [_vm._v("sentiment_satisfied_alt")])],
                    1
                  )
                ]
              }
            }
          ])
        },
        [
          _vm._v(" "),
          _c("span", [_vm._v(_vm._s(_vm.$t("Ajouter une emoticone")))])
        ]
      ),
      _vm._v(" "),
      _c(
        "v-menu",
        {
          attrs: {
            lazy: "",
            "close-on-content-click": false,
            transition: "scale-transition",
            origin: "bottom right",
            "max-width": _vm.width,
            "min-width": _vm.width,
            "position-x": _vm.x,
            "position-y": _vm.y,
            absolute: "",
            "offset-y": ""
          },
          model: {
            value: _vm.picker,
            callback: function($$v) {
              _vm.picker = $$v
            },
            expression: "picker"
          }
        },
        [
          _c("Picker", {
            attrs: {
              native: "",
              perLine: 8,
              color: _vm.$vuetify.theme.secondary,
              sheetSize: 16,
              emojiSize: 20,
              showSearch: true,
              showPreview: false,
              showSkinTones: false,
              showCategories: true,
              i18n: _vm.i18nPicker
            },
            on: {
              select: function(emoji) {
                return _vm.addEmoji(emoji)
              }
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6a6aa124", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6a6aa124","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/watcheebox/WzEmojiPicker.vue
// module id = null
// module chunks = 